import * as React from 'react';
import { Box, Card, CardMedia, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { services } from '../../siteData/Services';
import { pageViewEvent } from '../../MetaPixelEvents';
import SEO from '../../components/SEO/SEO';

const RenderMedia = ({ mediaObj }) => {
  const { thumbnail, thumbnailAltText } = mediaObj;
  return (
    <Card raised={false} sx={{ borderRadius: '20px', boxShadow: 'none' }}>
      <CardMedia component='img' image={thumbnail} alt={thumbnailAltText} />
    </Card>
  );
};

const RenderCopy = ({ svcObj }) => {
  const { name, description, bulletHeading, bullets } = svcObj;
  return (
    <Box>
      <Typography variant='body1' sx={{ fontSize: '20px', fontWeight: 'bold', lineHeight: '3 !important' }}>
        {name}
      </Typography>
      {/* <Typography variant='body1' sx={{ fontSize: '17px', fontWeight: 'bold', color: '#764b2d', pb: '20px' }}>
        {price}
      </Typography> */}
      <Typography variant='body1' sx={{ textAlign: 'justify' }}>
        {description}
      </Typography>
      <br />
      <Typography variant='body1'>{bulletHeading}</Typography>
      <ul style={{ paddingLeft: '20px' }}>
        {bullets.map((b, bIndex) => (
          <li key={bIndex}>
            <Typography variant='body1'>{b}</Typography>
          </li>
        ))}
      </ul>
    </Box>
  );
};

const Services = () => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  React.useEffect(() => {
    pageViewEvent();
  }, []);
  return (
    <>
      <SEO
        title='Mudrost Studio – Expert Food & Product Photography, Videography in Bangalore'
        description='Bangalore Creative studio, end-to-end content production for food and product brands. Team of photographers, cinematographers, craft high end branded content'
        keywords='food photography Bangalore, product photography Bangalore, commercial photography studio, food videography Bangalore, product videography services, ad film production Bangalore'
        url='https://mudrost.in/services'
        itempropDescription='Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.'
      />
      <Grid container sx={{ p: { xs: '30px 30px 0 30px', sm: '30px 30px 0 30px', md: '40px 40px 0 40px' } }}>
        <Typography variant='h2' component='h1' sx={{ pb: '10px' }}>
          Our Services
        </Typography>
        <Typography variant='body1' component='h2'>
          Great brands don't just look good. They're understood. We craft visuals and stories that make your audience
          stop, feel, and connect. Every service is designed to help you communicate with the people that matter most.
        </Typography>
      </Grid>
      <Grid container sx={{ p: { xs: '30px', sm: '30px', md: '40px' } }} spacing={mobile ? 8 : 20}>
        {services.map((s, sIndex) =>
          mobile ? (
            <React.Fragment key={sIndex}>
              <Grid item md={6} sm={12} xs={12}>
                <RenderMedia mediaObj={s} />
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <RenderCopy svcObj={s} />
              </Grid>
            </React.Fragment>
          ) : (
            <React.Fragment key={sIndex}>
              {sIndex % 2 === 0 ? (
                <>
                  <Grid item md={6} sm={12} xs={12}>
                    <RenderCopy svcObj={s} />
                  </Grid>
                  <Grid item md={6} sm={12} xs={12}>
                    <RenderMedia mediaObj={s} />
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item md={6} sm={12} xs={12}>
                    <RenderMedia mediaObj={s} />
                  </Grid>
                  <Grid item md={6} sm={12} xs={12}>
                    <RenderCopy svcObj={s} />
                  </Grid>
                </>
              )}
            </React.Fragment>
          )
        )}
      </Grid>
      <Grid container sx={{ p: { xs: '30px 30px 0 30px', sm: '30px 30px 0 30px', md: '40px 40px 0 40px' } }}>
        <Grid item md={12} sm={12} xs={12} sx={{ textAlign: 'center' }}>
          <Typography variant='body1'>
            Ready to bring your vision to life? Contact us today to discuss your project!
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Services;
